export default "__VITE_PUBLIC_ASSET__9f16cd86__"